import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyNumberList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ServiceVi = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "vi";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          VI
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/service">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/service">JA</Link>
            </li>
            <li className="selected">
              <em>VI</em>
            </li>
            <li>
              <Link to="/policy/th/service">TH</Link>
            </li>
            <li>
              <Link to="/policy/id/service">ID</Link>
            </li>
            <li>
              <Link to="/policy/es/service">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>Điều khoản sử dụng pregnancy&amp;baby</PolicyTitle>

      <PolicyVersion>
        <strong>Ngày có hiệu lực: [21 tháng 9 năm 2026]</strong>
        <br />
        <strong>Ngày cập nhật gần nhất: [25 tháng 8 năm 2026]</strong>
      </PolicyVersion>

      <PolicySectionTitle>
        Chương 1. Chào mừng bạn đến với pregnancy&amp;baby
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong> cung cấp nhiều dịch vụ nhằm hỗ trợ
        người dùng trong suốt quá trình chuẩn bị mang thai, điều trị hiếm muộn,
        mang thai, sinh con, phục hồi sau sinh và chăm sóc trẻ. Các dịch vụ này
        có thể bao gồm ghi chép thông tin sức khỏe và nhật ký, báo cáo được cá
        nhân hóa, nội dung thông tin, tính năng cộng đồng và các tính năng liên
        quan khác.
      </PolicyText>
      <PolicyText>
        Điều khoản sử dụng này (“Điều khoản”) áp dụng cho việc sử dụng ứng dụng
        di động <strong>pregnancy&amp;baby</strong>, trang web và các dịch vụ
        liên quan (gọi chung là “Dịch vụ”) do Connecti Co., Ltd. (“Công ty”,
        “chúng tôi”) cung cấp.
      </PolicyText>
      <PolicyText>
        Vui lòng đọc kỹ Điều khoản này trước khi sử dụng Dịch vụ.
      </PolicyText>

      <PolicyArticleTitle>Điều 1. Mục đích và định nghĩa</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Điều khoản này quy định quyền, nghĩa vụ, trách nhiệm, điều kiện sử
          dụng và các vấn đề khác liên quan đến việc sử dụng Dịch vụ giữa Công
          ty và người dùng đã đồng ý với Điều khoản này và hoàn tất đăng ký tài
          khoản (“Thành viên”).
        </li>
        <li>
          Trong Điều khoản này, các thuật ngữ dưới đây được hiểu như sau:
          <PolicyHyphenList>
            <li>
              <strong>“Dịch vụ”</strong> là ứng dụng di động pregnancy&amp;baby,
              trang web và các dịch vụ liên quan do Công ty cung cấp.
            </li>
            <li>
              <strong>“Thành viên”</strong> là người dùng đồng ý với Điều khoản
              này và hoàn tất đăng ký sử dụng Dịch vụ.
            </li>
            <li>
              <strong>“Tài khoản”</strong> là tài khoản được Thành viên sử dụng
              để truy cập và sử dụng Dịch vụ.
            </li>
            <li>
              <strong>“Thông tin tài khoản”</strong> là thông tin liên quan đến
              Tài khoản của Thành viên mà Thành viên có thể xem hoặc quản lý
              thông qua Dịch vụ.
            </li>
            <li>
              <strong>“Nội dung”</strong> là văn bản, hình ảnh, ảnh chụp, video,
              dữ liệu, thông tin, bình luận, bài đăng và các tài liệu khác được
              cung cấp thông qua hoặc được đăng tải, gửi lên Dịch vụ.
            </li>
            <li>
              <strong>“Dịch vụ trả phí”</strong> là nội dung kỹ thuật số, tính
              năng, báo cáo hoặc các dịch vụ khác do Công ty cung cấp và có thể
              sử dụng thông qua <strong>hình thức thanh toán một lần.</strong>
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 2. Hiệu lực và sửa đổi Điều khoản
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Điều khoản này có hiệu lực khi được hiển thị trong Dịch vụ hoặc được
          cung cấp bằng phương thức thích hợp khác và Thành viên đồng ý với Điều
          khoản.
        </li>
        <li>
          Công ty có thể sửa đổi Điều khoản này trong phạm vi được pháp luật
          hiện hành cho phép.
        </li>
        <li>
          Khi Điều khoản được sửa đổi, về nguyên tắc, Công ty sẽ thông báo cho
          Thành viên về nội dung sửa đổi và ngày có hiệu lực ít nhất{" "}
          <strong>15 ngày trước ngày Điều khoản sửa đổi có hiệu lực</strong>.
        </li>
        <li>
          Nếu nội dung sửa đổi gây bất lợi đáng kể cho Thành viên, về nguyên
          tắc, Công ty sẽ thông báo ít nhất{" "}
          <strong>30 ngày trước ngày có hiệu lực</strong> qua email, thông báo
          trong ứng dụng, thông báo đẩy hoặc phương thức điện tử thích hợp khác.
        </li>
        <li>
          Trong trường hợp pháp luật hiện hành cho phép, nếu Công ty thông báo
          rõ rằng việc Thành viên không phản đối trong một khoảng thời gian nhất
          định sẽ được xem là đồng ý với Điều khoản sửa đổi và Thành viên không
          phản đối trong khoảng thời gian đó, Thành viên có thể được xem là đã
          đồng ý với Điều khoản sửa đổi.
        </li>
        <li>
          Nếu Thành viên không đồng ý với Điều khoản sửa đổi, Thành viên có thể
          chấm dứt thỏa thuận sử dụng Dịch vụ bằng cách xóa Tài khoản.
        </li>
        <li>
          Điều khoản này về nguyên tắc được áp dụng từ ngày Thành viên đồng ý
          cho đến khi thỏa thuận sử dụng Dịch vụ chấm dứt. Những điều khoản mà
          theo bản chất cần tiếp tục có hiệu lực sau khi thỏa thuận chấm dứt có
          thể vẫn tiếp tục được áp dụng.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Điều 3. Các quy định bổ sung</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Những vấn đề không được quy định rõ trong Điều khoản này sẽ được điều
          chỉnh bởi pháp luật hiện hành, các điều khoản riêng áp dụng cho từng
          dịch vụ và các chính sách vận hành, hướng dẫn và quy định của Công ty
          (“Chính sách vận hành”).
        </li>
        <li>
          Nếu một Dịch vụ cụ thể có điều khoản bổ sung riêng, các điều khoản bổ
          sung đó sẽ được áp dụng cho Dịch vụ tương ứng.
        </li>
        <li>
          Nếu Điều khoản này mâu thuẫn với các quy định bắt buộc của pháp luật
          hiện hành, các quy định pháp luật đó sẽ được ưu tiên áp dụng.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>
        Chương 2. Đăng ký Thành viên và quản lý Tài khoản
      </PolicySectionTitle>
      <PolicyArticleTitle>Điều 4. Đăng ký Thành viên</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Người dùng được xem là đã đồng ý với Điều khoản này khi chọn nút hoặc
          ô đánh dấu “Đồng ý”, “Accept”, “Continue” hoặc nội dung tương đương
          được hiển thị trong quá trình đăng ký.
        </li>
        <li>
          Để đăng ký sử dụng Dịch vụ, người dùng phải cung cấp các thông tin cần
          thiết và hoàn tất quy trình đăng ký theo yêu cầu của Công ty.
        </li>
        <li>
          Thành viên có thể tạo hoặc truy cập Tài khoản thông qua các phương
          thức được Công ty hỗ trợ, bao gồm:
          <PolicyHyphenList>
            <li>Email</li>
            <li>Google</li>
            <li>Apple</li>
          </PolicyHyphenList>
        </li>
        <li>
          Công ty có thể yêu cầu cung cấp thêm thông tin hoặc thực hiện xác minh
          khi điều đó là cần thiết một cách hợp lý để cung cấp một tính năng cụ
          thể, bảo vệ Thành viên, tuân thủ pháp luật hiện hành hoặc ngăn chặn
          việc sử dụng Dịch vụ không đúng mục đích.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 5. Chấp thuận, tạm hoãn và từ chối đăng ký
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Việc đăng ký được hoàn tất khi người dùng gửi yêu cầu đăng ký và Công
          ty chấp thuận yêu cầu đó.
        </li>
        <li>
          Về nguyên tắc, Công ty sẽ chấp thuận yêu cầu đăng ký đã được hoàn tất
          hợp lệ. Tuy nhiên, Công ty có thể tạm hoãn, từ chối hoặc hủy đăng ký
          trong các trường hợp sau:
          <PolicyHyphenList>
            <li>
              Người đăng ký sử dụng trái phép danh tính, địa chỉ email, tài
              khoản hoặc thông tin khác của người khác;
            </li>
            <li>
              Người đăng ký cung cấp thông tin sai lệch, không đầy đủ hoặc gây
              hiểu nhầm;
            </li>
            <li>
              Công ty không có đủ năng lực kỹ thuật hợp lý để cung cấp Dịch vụ;
            </li>
            <li>
              Các vấn đề kỹ thuật hoặc vận hành khiến việc cung cấp Dịch vụ gặp
              khó khăn;
            </li>
            <li>
              Người từng bị đình chỉ hoặc hạn chế sử dụng Dịch vụ cố gắng tránh
              biện pháp hạn chế bằng cách tạo Tài khoản khác;
            </li>
            <li>
              Việc đăng ký vi phạm pháp luật hiện hành, Điều khoản này hoặc
              Chính sách vận hành; hoặc
            </li>
            <li>
              Công ty có cơ sở hợp lý để xác định rằng không thể chấp thuận đăng
              ký vì lý do chính đáng về kỹ thuật, bảo mật, vận hành hoặc pháp
              lý.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Nếu sau khi đăng ký, Công ty phát hiện Thành viên đã đăng ký trái với
          Điều này, Công ty có thể áp dụng các biện pháp phù hợp như hạn chế sử
          dụng Dịch vụ, đình chỉ hoặc xóa Tài khoản.
        </li>
      </PolicyNumberList>
      <PolicyArticleTitle>Điều 6. Quản lý Tài khoản</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Thành viên có trách nhiệm quản lý Tài khoản của mình một cách phù hợp
          và ngăn chặn việc sử dụng trái phép bởi bên thứ ba.
        </li>
        <li>
          Nếu phát hiện Tài khoản bị truy cập hoặc sử dụng trái phép, Thành viên
          phải nhanh chóng thực hiện các biện pháp hợp lý để bảo vệ Tài khoản và
          thông báo cho Công ty.
        </li>
        <li>
          Thành viên có thể xem hoặc thay đổi một số Thông tin tài khoản thông
          qua Dịch vụ. Một số thông tin có thể không được phép chỉnh sửa trực
          tiếp nếu việc hạn chế là cần thiết vì lý do bảo mật tài khoản, nhận
          dạng hoặc kỹ thuật.
        </li>
        <li>
          Nếu cần thay đổi thông tin không thể chỉnh sửa trực tiếp, Thành viên
          có thể liên hệ với bộ phận Hỗ trợ khách hàng.
        </li>
        <li>
          Khi sử dụng đăng nhập bằng Google, Apple, việc xác thực được thực hiện
          thông qua mã thông báo (token) hoặc cơ chế xác thực khác do dịch vụ
          bên thứ ba tương ứng cung cấp. Công ty không cung cấp chức năng khôi
          phục mật khẩu đối với thông tin đăng nhập do các nhà cung cấp bên thứ
          ba này quản lý.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Chương 3. Sử dụng Dịch vụ</PolicySectionTitle>
      <PolicyArticleTitle>Điều 7. Cung cấp Dịch vụ</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Thành viên có thể sử dụng Dịch vụ sau khi hoàn tất đăng ký và các thủ
          tục cần thiết đối với tính năng tương ứng.
        </li>
        <li>
          Dịch vụ có thể bao gồm, nhưng không giới hạn ở, các tính năng sau:
          <PolicyHyphenList>
            <li>Chuẩn bị mang thai và theo dõi chu kỳ kinh nguyệt</li>
            <li>
              Ghi chép và phân tích kết quả que thử rụng trứng và que thử thai
            </li>
            <li>Ghi chép quá trình điều trị hiếm muộn</li>
            <li>Nhật ký thai kỳ và các báo cáo liên quan đến thai kỳ</li>
            <li>Báo cáo tăng trưởng của thai nhi</li>
            <li>Quản lý cân nặng trong thai kỳ và sau sinh</li>
            <li>
              Các tính năng liên quan đến tăng trưởng và phát triển của trẻ
            </li>
            <li>Ghi chép sức khỏe và chăm sóc trẻ</li>
            <li>Hướng dẫn và nội dung thông tin</li>
            <li>Tính năng cộng đồng</li>
            <li>Các tính năng khác do Công ty cung cấp</li>
          </PolicyHyphenList>
        </li>
        <li>
          Một số tính năng có thể yêu cầu:
          <PolicyHyphenList>
            <li>Cung cấp thêm thông tin;</li>
            <li>
              Đồng ý riêng, bao gồm đồng ý liên quan đến việc xử lý thông tin
              sức khỏe hoặc dữ liệu cá nhân nhạy cảm khác;
            </li>
            <li>Đáp ứng yêu cầu về độ tuổi hoặc điều kiện sử dụng;</li>
            <li>Đồng ý với các điều khoản hoặc chính sách bổ sung; hoặc</li>
            <li>
              Đáp ứng các yêu cầu hợp lý khác cần thiết để cung cấp tính năng.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Công ty có thể cung cấp các bản cập nhật phần mềm nhằm cải thiện hoặc
          thay đổi Dịch vụ hoặc thêm, xóa các tính năng. Thành viên được khuyến
          nghị sử dụng phiên bản mới nhất của ứng dụng khi có thể.
        </li>
        <li>
          Công ty có thể hiển thị trong Dịch vụ các thông báo về dịch vụ, thông
          báo quản trị, nội dung thông tin hoặc các thông báo khác.
        </li>
        <li>
          Email, thông báo đẩy hoặc các thông tin liên lạc tương tự có mục đích
          thương mại hoặc quảng bá sẽ được gửi theo sự đồng ý của Thành viên và
          phù hợp với pháp luật hiện hành.
        </li>
        <li>
          Nếu phát hiện lỗi hệ thống hoặc vấn đề khác trong quá trình sử dụng
          Dịch vụ, Thành viên có thể liên hệ với bộ phận Hỗ trợ khách hàng tại:
          <br />
          <a href="mailto:after10month@connect-i.co.kr">
            after10month@connect-i.co.kr
          </a>
        </li>
        <li>
          Thành viên chịu trách nhiệm đối với mọi khoản phí dữ liệu hoặc viễn
          thông do nhà cung cấp dịch vụ internet hoặc nhà mạng di động tính khi
          sử dụng Dịch vụ.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 8. Tạm ngừng, thay đổi và chấm dứt Dịch vụ
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Công ty sẽ nỗ lực hợp lý để cung cấp Dịch vụ một cách liên tục và ổn
          định.
        </li>
        <li>
          Trừ trường hợp pháp luật có quy định khác, toàn bộ hoặc một phần Dịch
          vụ có thể bị hạn chế, tạm ngừng, thay đổi hoặc chấm dứt trong các
          trường hợp sau:
          <PolicyHyphenList>
            <li>
              Bảo trì, kiểm tra, sửa chữa hoặc thay thế hệ thống, thiết bị;
            </li>
            <li>
              Mất điện, hỏng thiết bị, tắc nghẽn mạng hoặc vấn đề kỹ thuật khác;
            </li>
            <li>
              Chấm dứt hoặc thay đổi thỏa thuận với nhà cung cấp dịch vụ bên thứ
              ba;
            </li>
            <li>Lệnh của cơ quan nhà nước, quy định hoặc yêu cầu pháp lý;</li>
            <li>Thay đổi chính sách vận hành, bảo mật hoặc dịch vụ;</li>
            <li>
              Thiên tai, tình trạng khẩn cấp, chiến tranh, bất ổn xã hội hoặc
              các sự kiện bất khả kháng khác; hoặc
            </li>
            <li>
              Các trường hợp khác khiến việc tiếp tục cung cấp Dịch vụ trở nên
              không khả thi.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Khi có thể thực hiện một cách hợp lý, Công ty sẽ thông báo trước về
          việc tạm ngừng hoặc chấm dứt Dịch vụ có ảnh hưởng đáng kể theo phương
          thức quy định tại Điều 21.
        </li>
        <li>
          Công ty có thể không thể thông báo trước nếu việc tạm ngừng phát sinh
          do các trường hợp bất ngờ hoặc ngoài khả năng kiểm soát, chẳng hạn như
          lỗi máy chủ, sự cố hệ thống, sự cố bảo mật hoặc lỗi hệ thống của bên
          thứ ba.
        </li>
        <li>
          Trong những trường hợp đó, Công ty sẽ nỗ lực hợp lý để khôi phục Dịch
          vụ trong thời gian sớm nhất có thể.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 9. Quản lý Nội dung của Thành viên
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Nếu Nội dung do Thành viên đăng tải xâm phạm quyền tác giả, quyền
          riêng tư, quyền sở hữu trí tuệ hoặc các quyền khác, chủ thể quyền có
          thể yêu cầu Công ty thực hiện biện pháp phù hợp theo pháp luật hiện
          hành.
        </li>
        <li>
          Công ty có thể hạn chế quyền truy cập, tạm thời xóa hoặc xóa vĩnh viễn
          Nội dung nếu Công ty có cơ sở hợp lý để xác định rằng Nội dung:
          <PolicyHyphenList>
            <li>Vi phạm pháp luật hiện hành;</li>
            <li>Xâm phạm quyền của người khác;</li>
            <li>Vi phạm Điều khoản này hoặc Chính sách vận hành;</li>
            <li>
              Đe dọa tính bảo mật hoặc hoạt động bình thường của Dịch vụ; hoặc
            </li>
            <li>Cần được xử lý để bảo vệ Thành viên hoặc bên thứ ba.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Các thủ tục liên quan đến báo cáo vi phạm, gỡ bỏ và các biện pháp xử
          lý Nội dung khác có thể được quy định chi tiết hơn trong Chính sách
          vận hành.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 10. Quyền sở hữu và sử dụng Nội dung
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Thành viên có thể đăng tải ảnh, văn bản, thông tin, video, bình luận,
          đề xuất và các Nội dung khác lên Dịch vụ.
        </li>
        <li>
          Thành viên tiếp tục sở hữu các quyền sở hữu trí tuệ mà mình có đối với
          Nội dung do mình đăng tải.
        </li>
        <li>
          Khi đăng tải Nội dung tại các khu vực của Dịch vụ được thiết kế để
          chia sẻ với người khác, Thành viên cấp cho Công ty quyền sử dụng không
          độc quyền để lưu trữ, sao chép, hiển thị, định dạng và thực hiện các
          sửa đổi kỹ thuật đối với Nội dung đó trong phạm vi hợp lý cần thiết để
          vận hành, hiển thị, cung cấp và cải thiện tính năng tương ứng.
        </li>
        <li>
          Nội dung của Thành viên có thể xuất hiện trong kết quả tìm kiếm, bảng
          tin, khu vực nội dung được cá nhân hóa hoặc các vị trí khác trong Dịch
          vụ phù hợp với tính năng nơi Nội dung được đăng tải.
        </li>
        <li>
          Công ty có thể từ chối, hạn chế hoặc xóa Nội dung mà không cần thông
          báo trước nếu có cơ sở hợp lý để xác định Nội dung đó:
          <PolicyHyphenList>
            <li>Là bất hợp pháp;</li>
            <li>Có tính chất khiêu dâm hoặc bóc lột tình dục;</li>
            <li>
              Khuyến khích thù ghét, phân biệt đối xử trái pháp luật hoặc bạo
              lực;
            </li>
            <li>Là thư rác hoặc quảng cáo không được phép;</li>
            <li>Mạo danh người khác;</li>
            <li>Xâm phạm quyền của bên thứ ba;</li>
            <li>Có tính chất gian lận hoặc gây hiểu nhầm; hoặc</li>
            <li>Vi phạm Điều khoản này hoặc Chính sách vận hành.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Công ty không có nghĩa vụ chủ động kiểm duyệt trước toàn bộ Nội dung
          của Thành viên.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 11. Hạn chế và hành vi bị cấm khi sử dụng Dịch vụ
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Thành viên không được thực hiện các hành vi sau:
          <PolicyHyphenList>
            <li>
              Cung cấp thông tin sai lệch hoặc sử dụng không đúng cách Tài khoản
              hoặc danh tính của người khác;
            </li>
            <li>
              Sao chép, sửa đổi, phân phối, bán, chuyển nhượng, cho mượn, dịch
              ngược, biên dịch ngược hoặc cố gắng trích xuất mã nguồn của Dịch
              vụ khi chưa được phép, trừ trường hợp pháp luật hiện hành cho phép
              rõ ràng;
            </li>
            <li>Phỉ báng, đe dọa, quấy rối hoặc gây tổn hại cho người khác;</li>
            <li>
              Đăng tải tài liệu bất hợp pháp, khiêu dâm, mang tính bóc lột hoặc
              bị cấm khác;
            </li>
            <li>
              Xâm phạm quyền tác giả, nhãn hiệu, quyền riêng tư hoặc các quyền
              khác của Công ty hoặc bên thứ ba;
            </li>
            <li>
              Công bố thông tin sai lệch hoặc gây hiểu nhầm về Công ty hoặc
              người khác;
            </li>
            <li>
              Phân phối Nội dung trái với pháp luật hiện hành hoặc trật tự công
              cộng;
            </li>
            <li>
              Đưa vào Dịch vụ phần mềm độc hại, vi-rút, mã độc hoặc nội dung
              khác nhằm gây hư hại hoặc gián đoạn Dịch vụ;
            </li>
            <li>
              Cố ý can thiệp hoặc làm gián đoạn hoạt động bình thường của Dịch
              vụ;
            </li>
            <li>
              Mạo danh người khác hoặc khai báo sai về mối quan hệ với một cá
              nhân hoặc tổ chức;
            </li>
            <li>
              Thu thập, lưu trữ hoặc công khai Dữ liệu cá nhân của Thành viên
              khác khi không có thẩm quyền hợp pháp;
            </li>
            <li>
              Phát tán thông tin gian lận nhằm thu lợi tài chính hoặc gây thiệt
              hại;
            </li>
            <li>
              Tham gia đánh bạc trái pháp luật hoặc các hoạt động bất hợp pháp
              khác;
            </li>
            <li>
              Mời chào hoặc tạo điều kiện cho các dịch vụ tình dục bất hợp pháp
              hoặc hành vi bóc lột;
            </li>
            <li>
              Liên tục gửi Nội dung nhằm gây sợ hãi, nhục nhã, quấy rối hoặc đau
              khổ nghiêm trọng cho người khác;
            </li>
            <li>
              Truyền tải hoặc công bố thông tin bị pháp luật hiện hành cấm;
            </li>
            <li>
              Mạo danh nhân viên Công ty, người quản lý Dịch vụ hoặc đối tác
              kinh doanh;
            </li>
            <li>
              Lạm dụng hệ thống báo cáo thông qua các báo cáo sai sự thật hoặc
              có ác ý;
            </li>
            <li>
              Theo dõi, có hành vi lăng mạ hoặc bằng cách khác cản trở Thành
              viên khác sử dụng Dịch vụ; hoặc
            </li>
            <li>
              Vi phạm pháp luật hiện hành, Điều khoản này hoặc Chính sách vận
              hành bằng bất kỳ hình thức nào khác.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Quyền truy cập vào một số Dịch vụ có thể bị hạn chế dựa trên độ tuổi,
          điều kiện sử dụng, khu vực pháp lý hoặc các yêu cầu pháp lý khác.
        </li>
        <li>
          Khi Thành viên vi phạm Điều này, Công ty có thể điều tra và thực hiện
          các biện pháp như xóa Nội dung, tạm thời hoặc vĩnh viễn hạn chế một số
          tính năng, đình chỉ Tài khoản hoặc chấm dứt thỏa thuận sử dụng Dịch
          vụ.
        </li>
        <li>
          Công ty có thể áp dụng ngay các biện pháp nghiêm khắc hơn trong trường
          hợp có hành vi trái pháp luật nghiêm trọng, gây thiệt hại đáng kể cho
          người khác, đe dọa an toàn, gây rủi ro bảo mật hoặc vi phạm nhiều lần.
        </li>
        <li>
          Thành viên có thể liên hệ với bộ phận Hỗ trợ khách hàng để yêu cầu xem
          xét lại biện pháp hạn chế do Công ty áp dụng.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 12. Chấm dứt thỏa thuận sử dụng Dịch vụ
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Khi Thành viên xóa Tài khoản, thỏa thuận sử dụng Dịch vụ giữa Thành
          viên và Công ty cũng chấm dứt.
        </li>
        <li>
          Thành viên có thể yêu cầu xóa Tài khoản bất cứ lúc nào thông qua chức
          năng được cung cấp trong Dịch vụ hoặc bằng cách liên hệ với bộ phận Hỗ
          trợ khách hàng.
        </li>
        <li>
          Khi thỏa thuận sử dụng Dịch vụ chấm dứt, thông tin Thành viên và dữ
          liệu Dịch vụ sẽ được xử lý theo pháp luật hiện hành và{" "}
          <strong>Chính sách quyền riêng tư của pregnancy&amp;baby</strong>.
        </li>
        <li>
          Dữ liệu cá nhân có thể nhận dạng Thành viên sẽ được xóa theo Chính
          sách quyền riêng tư, trừ trường hợp pháp luật hiện hành yêu cầu hoặc
          cho phép lưu giữ.
        </li>
        <li>
          Một số dữ liệu Dịch vụ có thể được ẩn danh theo cách không thể đảo
          ngược và được lưu giữ cho mục đích nghiên cứu, thống kê, phân tích và
          cải thiện Dịch vụ như được mô tả trong Chính sách quyền riêng tư.
        </li>
        <li>
          Nội dung mà Thành viên đã chia sẻ công khai hoặc với Thành viên khác,
          bao gồm bài đăng và bình luận trong cộng đồng, có thể không tự động bị
          xóa khi Tài khoản bị xóa nếu Nội dung đó là một phần trong cuộc trò
          chuyện, tương tác hoặc khu vực chia sẻ với Thành viên khác.
        </li>
        <li>
          Thành viên được khuyến nghị tự xóa Nội dung mà mình muốn xóa trước khi
          xóa Tài khoản. Nếu Nội dung vẫn còn sau khi Tài khoản bị xóa, các
          Thông tin tài khoản có thể nhận dạng Thành viên, chẳng hạn như biệt
          danh, có thể được xóa hoặc tách khỏi Nội dung khi phù hợp.
        </li>
        <li>
          Nếu Thành viên sử dụng dịch vụ đăng nhập của bên thứ ba như Google,
          Apple và xóa hoặc ngắt kết nối tài khoản bên thứ ba đó, Thành viên có
          thể không còn truy cập được pregnancy&amp;baby bằng phương thức đăng
          nhập tương ứng.
        </li>
        <li>
          Dữ liệu đã bị xóa khi xóa Tài khoản về nguyên tắc không thể khôi phục.
        </li>
        <li>
          Thành viên cũ có thể đăng ký tạo Tài khoản mới, trừ trường hợp việc
          đăng ký lại bị hạn chế do trước đó đã vi phạm pháp luật hiện hành,
          Điều khoản này hoặc Chính sách vận hành.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Điều 13. Bảo vệ Dữ liệu cá nhân</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Công ty xử lý Dữ liệu cá nhân trong phạm vi cần thiết để cung cấp Dịch
          vụ và tuân thủ pháp luật hiện hành về quyền riêng tư và bảo vệ dữ liệu
          cá nhân.
        </li>
        <li>
          Dữ liệu cá nhân chỉ được xử lý cho các mục đích và trong phạm vi được
          mô tả trong Chính sách quyền riêng tư của Công ty, các thông báo xin ý
          kiến đồng ý có liên quan và các thông báo khác theo yêu cầu của pháp
          luật.
        </li>
        <li>
          Khi một tính năng yêu cầu xử lý thông tin sức khỏe hoặc Dữ liệu cá
          nhân nhạy cảm khác, Công ty sẽ thu thập sự đồng ý theo yêu cầu của
          pháp luật hiện hành.
        </li>
        <li>
          Công ty sẽ không cung cấp Dữ liệu cá nhân cho các bên thứ ba độc lập,
          ngoại trừ các trường hợp sau:
          <PolicyHyphenList>
            <li>Có sự đồng ý của Thành viên;</li>
            <li>Theo nội dung được mô tả trong Chính sách quyền riêng tư;</li>
            <li>
              Cung cấp cho nhà cung cấp dịch vụ xử lý dữ liệu thay mặt Công ty;
            </li>
            <li>Khi pháp luật yêu cầu hoặc cho phép; hoặc</li>
            <li>Trong các trường hợp khác được pháp luật cho phép.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Thông tin chi tiết về việc Công ty thu thập, sử dụng, chia sẻ, lưu
          giữ, chuyển dữ liệu ra nước ngoài và bảo vệ Dữ liệu cá nhân được quy
          định trong{" "}
          <strong>Chính sách quyền riêng tư của pregnancy&amp;baby</strong>.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Chương 4. Dịch vụ trả phí</PolicySectionTitle>
      <PolicyArticleTitle>
        Điều 14. Thông tin về Dịch vụ trả phí
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Nếu Công ty cung cấp Dịch vụ trả phí, Thành viên có thể sử dụng dịch
          vụ đó bằng cách thanh toán <strong>một lần</strong> theo các điều kiện
          được hiển thị đối với Dịch vụ trả phí tương ứng.
        </li>
        <li>
          Trước khi hoàn tất giao dịch mua, Công ty hoặc cửa hàng ứng dụng tương
          ứng sẽ cung cấp để Thành viên có thể xem một cách hợp lý các thông tin
          chính như:
          <PolicyHyphenList>
            <li>Tên hoặc mô tả Dịch vụ trả phí;</li>
            <li>Nhà cung cấp Dịch vụ trả phí;</li>
            <li>Nội dung và các tính năng chính của Dịch vụ trả phí;</li>
            <li>Giá áp dụng; và</li>
            <li>
              Các điều kiện mua hàng quan trọng khác theo yêu cầu của pháp luật
              hiện hành.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Khả năng sử dụng Dịch vụ trả phí có thể phụ thuộc vào thiết bị, hệ
          điều hành, quốc gia, cửa hàng ứng dụng và các yêu cầu kỹ thuật khác
          của người dùng.
        </li>
        <li>
          Trừ khi có quy định rõ ràng khác, Dịch vụ trả phí là{" "}
          <strong>
            giao dịch mua một lần, không tự động gia hạn và không phát sinh
            khoản phí định kỳ
          </strong>
          .
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 15. Xác lập thỏa thuận sử dụng Dịch vụ trả phí
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Thành viên có thể mua Dịch vụ trả phí thông qua quy trình mua hàng do
          Công ty hoặc cửa hàng ứng dụng tương ứng cung cấp.
        </li>
        <li>
          Quy trình mua hàng có thể bao gồm:
          <PolicyHyphenList>
            <li>Xem xét và lựa chọn Dịch vụ trả phí;</li>
            <li>Xem xét giá và các điều kiện quan trọng;</li>
            <li>Lựa chọn phương thức thanh toán có sẵn;</li>
            <li>Xác nhận giao dịch mua; và</li>
            <li>Hoàn tất thanh toán.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Thỏa thuận sử dụng Dịch vụ trả phí được xác lập khi giao dịch mua được
          hoàn tất thành công và thông báo xác nhận mua hàng được hiển thị hoặc
          cung cấp bằng phương thức tương đương.
        </li>
        <li>
          Công ty có thể từ chối, hủy hoặc tạm dừng giao dịch nếu:
          <PolicyHyphenList>
            <li>
              Thông tin sai lệch hoặc thông tin được sử dụng trái phép được sử
              dụng trong giao dịch;
            </li>
            <li>
              Phương thức thanh toán không được sử dụng với thẩm quyền hợp pháp;
            </li>
            <li>Thành viên không có tư cách pháp lý để thực hiện giao dịch;</li>
            <li>
              Vấn đề kỹ thuật hoặc vận hành khiến giao dịch không thể hoàn tất;
            </li>
            <li>
              Tài khoản của Thành viên đang bị đình chỉ hoặc hạn chế; hoặc
            </li>
            <li>
              Giao dịch vi phạm pháp luật hiện hành, Điều khoản này hoặc chính
              sách của cửa hàng ứng dụng tương ứng.
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 16. Thanh toán Dịch vụ trả phí
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Các phương thức thanh toán dành cho Thành viên có thể khác nhau tùy
          theo quốc gia, thiết bị, nền tảng và các phương thức được cửa hàng ứng
          dụng hoặc nhà cung cấp dịch vụ thanh toán tương ứng hỗ trợ.
        </li>
        <li>
          Khi Dịch vụ trả phí được mua thông qua ứng dụng di động, khoản thanh
          toán có thể được xử lý dưới dạng{" "}
          <strong>
            giao dịch mua hàng trong ứng dụng một lần (one-time in-app purchase)
          </strong>{" "}
          thông qua:
          <PolicyHyphenList>
            <li>Apple App Store</li>
            <li>Google Play</li>
          </PolicyHyphenList>
        </li>
        <li>
          Các khoản thanh toán được thực hiện thông qua cửa hàng ứng dụng phải
          tuân theo điều khoản thanh toán, quy tắc lập hóa đơn, thủ tục hủy giao
          dịch, chính sách hoàn tiền và các chính sách liên quan khác của cửa
          hàng ứng dụng đó.
        </li>
        <li>
          Thành viên chỉ được sử dụng các phương thức thanh toán mà mình có
          quyền sử dụng hợp pháp.
        </li>
        <li>
          Thành viên có trách nhiệm đảm bảo thông tin cung cấp liên quan đến
          thanh toán là chính xác và được sử dụng hợp pháp.
        </li>
        <li>
          Nhà cung cấp dịch vụ thanh toán hoặc cửa hàng ứng dụng có thể áp dụng
          giới hạn giao dịch, giới hạn theo khu vực, yêu cầu về độ tuổi hoặc các
          điều kiện khác.
        </li>
        <li>
          Công ty không lưu trữ đầy đủ thông tin thẻ thanh toán nếu việc thanh
          toán được xử lý hoàn toàn bởi cửa hàng ứng dụng hoặc nhà cung cấp dịch
          vụ thanh toán độc lập.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 17. Hủy giao dịch và quyền rút lại đối với Dịch vụ trả phí
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Việc Thành viên có thể hủy giao dịch mua, thực hiện quyền rút lại giao
          dịch hoặc được hoàn tiền đối với Dịch vụ trả phí hay không sẽ được xác
          định dựa trên:
          <PolicyHyphenList>
            <li>Pháp luật bảo vệ người tiêu dùng hiện hành;</li>
            <li>Tính chất của Dịch vụ trả phí;</li>
            <li>
              Việc Dịch vụ trả phí đã được cung cấp hoặc sử dụng hay chưa;
            </li>
            <li>Các điều kiện được thông báo tại thời điểm mua; và</li>
            <li>
              Nếu mua thông qua cửa hàng ứng dụng, chính sách của cửa hàng ứng
              dụng tương ứng.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Đối với giao dịch mua thông qua Apple App Store hoặc Google Play, yêu
          cầu hủy giao dịch, rút lại giao dịch hoặc hoàn tiền có thể cần được
          Thành viên gửi trực tiếp thông qua cửa hàng ứng dụng tương ứng theo
          chính sách của cửa hàng đó.
        </li>
        <li>
          Một số nội dung kỹ thuật số hoặc dịch vụ có thể không đủ điều kiện để
          rút lại giao dịch hoặc hoàn tiền sau khi việc cung cấp hoặc sử dụng đã
          bắt đầu, nếu pháp luật hiện hành cho phép và các thông báo hoặc sự
          đồng ý bắt buộc theo pháp luật đã được thực hiện.
        </li>
        <li>
          Điều khoản này không hạn chế bất kỳ quyền bắt buộc nào về hủy giao
          dịch, rút lại giao dịch hoặc hoàn tiền mà Thành viên được hưởng theo
          pháp luật hiện hành.
        </li>
        <li>
          Các quyền lợi, phiếu ưu đãi hoặc lợi ích bổ sung khác được cung cấp
          liên quan đến giao dịch đã được hoàn tiền có thể bị thu hồi hoặc hạn
          chế sử dụng trong phạm vi pháp luật hiện hành cho phép.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 18. Hạn chế sử dụng Dịch vụ trả phí
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Công ty sẽ cung cấp Dịch vụ trả phí đã được mua hợp lệ để Thành viên
          có thể sử dụng theo các điều kiện được thông báo đối với dịch vụ đó.
        </li>
        <li>
          Công ty có thể hạn chế hoặc tạm ngừng quyền truy cập vào Dịch vụ trả
          phí trong phạm vi pháp luật hiện hành cho phép nếu Thành viên:
          <PolicyHyphenList>
            <li>Vi phạm Điều khoản này;</li>
            <li>Thực hiện hành vi gian lận hoặc trái pháp luật;</li>
            <li>Sử dụng phương thức thanh toán trái phép;</li>
            <li>Lạm dụng hệ thống thanh toán hoặc hoàn tiền; hoặc</li>
            <li>
              Thực hiện hành vi khác tạo cơ sở hợp lý để áp dụng biện pháp hạn
              chế theo pháp luật hiện hành.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Khi thích hợp, Thành viên có thể liên hệ với bộ phận Hỗ trợ khách hàng
          để yêu cầu xem xét lại biện pháp hạn chế.
        </li>
        <li>
          Việc hạn chế sử dụng Dịch vụ trả phí không làm chấm dứt Tài khoản
          pregnancy&amp;baby của Thành viên, trừ khi có quy định rõ ràng khác.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Điều 19. Hoàn tiền</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Điều kiện được hoàn tiền và số tiền hoàn lại phụ thuộc vào pháp luật
          hiện hành, loại Dịch vụ trả phí, việc dịch vụ hoặc nội dung kỹ thuật
          số đã được cung cấp hoặc sử dụng hay chưa và chính sách được thông báo
          tại thời điểm mua.
        </li>
        <li>
          Nếu giao dịch được thanh toán thông qua{" "}
          <strong>Apple App Store hoặc Google Play</strong>, về nguyên tắc,
          chính sách và thủ tục hoàn tiền của cửa hàng ứng dụng tương ứng sẽ
          được áp dụng và Công ty có thể không thể trực tiếp thực hiện việc hoàn
          tiền.
        </li>
        <li>
          Một số nội dung kỹ thuật số hoặc dịch vụ có thể không được hoàn tiền
          sau khi việc cung cấp hoặc sử dụng đã bắt đầu nếu pháp luật hiện hành
          cho phép và các thông báo hoặc sự đồng ý bắt buộc theo pháp luật đã
          được thực hiện.
        </li>
        <li>
          Nếu một Dịch vụ trả phí cụ thể có chính sách hoàn tiền riêng, Công ty
          sẽ cung cấp chính sách đó trong quá trình mua hàng.
        </li>
        <li>
          Không nội dung nào trong Điều này loại trừ hoặc hạn chế các quyền về
          hoàn tiền, hủy giao dịch, rút lại giao dịch hoặc quyền khác của người
          tiêu dùng mà theo pháp luật áp dụng cho Thành viên không thể bị loại
          trừ hoặc hạn chế.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Chương 5. Các quy định khác</PolicySectionTitle>
      <PolicyArticleTitle>Điều 20. Miễn trừ và trách nhiệm</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Trong phạm vi tối đa được pháp luật hiện hành cho phép, Công ty không
          đưa ra bảo đảm đối với các vấn đề không được quy định rõ trong Điều
          khoản này.
        </li>
        <li>
          Công ty không bảo đảm tính đầy đủ, chính xác, đáng tin cậy hoặc phù
          hợp cho một mục đích cụ thể của thông tin do các nguồn sau cung cấp:
          <PolicyHyphenList>
            <li>Thành viên;</li>
            <li>Nhà cung cấp nội dung bên thứ ba;</li>
            <li>Cơ sở dữ liệu công cộng;</li>
            <li>Dịch vụ bên ngoài; hoặc</li>
            <li>Các nguồn thông tin độc lập khác.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Dịch vụ, bao gồm dự đoán chu kỳ kinh nguyệt, ước tính thời kỳ dễ thụ
          thai, các phép tính liên quan đến thai kỳ, phân tích sự phát triển của
          thai nhi, thông tin về tăng trưởng và phát triển của trẻ và các tính
          năng liên quan đến sức khỏe khác, được cung cấp nhằm{" "}
          <strong>mục đích cung cấp thông tin và hỗ trợ người dùng</strong>.
        </li>
        <li>
          Dịch vụ không cấu thành và không nhằm thay thế việc chẩn đoán, thăm
          khám, điều trị hoặc tư vấn y khoa chuyên nghiệp.
        </li>
        <li>
          Nếu thiệt hại phát sinh do hành vi cố ý hoặc lỗi bất cẩn của Công ty,
          Công ty sẽ chịu trách nhiệm theo pháp luật hiện hành.
        </li>
        <li>
          Trong phạm vi pháp luật hiện hành cho phép, Công ty không chịu trách
          nhiệm đối với thiệt hại không phát sinh do hành vi cố ý hoặc lỗi bất
          cẩn của Công ty, bao gồm thiệt hại chỉ phát sinh từ:
          <PolicyHyphenList>
            <li>
              Sự kiện bất khả kháng hoặc tình huống nằm ngoài khả năng kiểm soát
              hợp lý của Công ty;
            </li>
            <li>Hành vi hoặc sự thiếu sót của Thành viên;</li>
            <li>
              Việc truy cập trái phép hoặc tấn công của bên thứ ba mà Công ty
              không thể ngăn chặn một cách hợp lý;
            </li>
            <li>Phần mềm độc hại do bên thứ ba đưa vào;</li>
            <li>
              Lỗi của mạng, hệ thống hoặc dịch vụ của bên thứ ba nằm ngoài khả
              năng kiểm soát hợp lý của Công ty; hoặc
            </li>
            <li>
              Các tình huống khác không phát sinh do hành vi cố ý hoặc lỗi bất
              cẩn của Công ty.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Trong phạm vi pháp luật hiện hành cho phép, Công ty không chịu trách
          nhiệm đối với tranh chấp chỉ phát sinh giữa các Thành viên hoặc giữa
          Thành viên và bên thứ ba độc lập, trừ trường hợp Công ty có trách
          nhiệm pháp lý đối với vấn đề đó.
        </li>
        <li>
          Không nội dung nào trong Điều khoản này loại trừ hoặc hạn chế trách
          nhiệm mà theo pháp luật bảo vệ người tiêu dùng hoặc các quy định pháp
          luật bắt buộc khác không thể bị loại trừ hoặc hạn chế.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Điều 21. Thông báo và liên lạc</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Thành viên có thể liên hệ với Công ty thông qua bộ phận Hỗ trợ khách
          hàng bất cứ lúc nào về các vấn đề liên quan đến Dịch vụ.
        </li>
        <li>
          Các thông báo chung dành cho Thành viên có thể được đăng trong phần
          thông báo của Dịch vụ trong ít nhất bảy (7) ngày hoặc được cung cấp
          bằng phương thức hợp lý khác.
        </li>
        <li>
          Các vấn đề ảnh hưởng đáng kể đến quyền hoặc việc sử dụng Dịch vụ của
          Thành viên có thể được thông báo riêng thông qua:
          <PolicyHyphenList>
            <li>Email;</li>
            <li>Thông báo đẩy;</li>
            <li>Tin nhắn trong ứng dụng; hoặc</li>
            <li>Phương thức điện tử thích hợp khác.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Công ty không có nghĩa vụ sử dụng phương thức liên lạc mà Thành viên
          chưa cung cấp thông tin cần thiết để nhận thông báo theo phương thức
          đó.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Điều 22. Luật áp dụng và giải quyết tranh chấp
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Điều khoản này và mối quan hệ giữa Công ty và Thành viên về nguyên tắc
          được điều chỉnh bởi pháp luật của <strong>Đại Hàn Dân Quốc</strong>,
          với điều kiện không làm ảnh hưởng đến các quy định bắt buộc về bảo vệ
          người tiêu dùng hoặc các quyền bắt buộc khác được áp dụng theo pháp
          luật của quốc gia hoặc khu vực nơi Thành viên cư trú.
        </li>
        <li>
          Nếu phát sinh tranh chấp liên quan đến Dịch vụ, Công ty và Thành viên
          trước tiên sẽ nỗ lực hợp lý để giải quyết vấn đề thông qua trao đổi và
          thương lượng thiện chí.
        </li>
        <li>
          Nếu tranh chấp không thể được giải quyết bằng thương lượng, tranh chấp
          có thể được đưa ra tòa án có thẩm quyền theo pháp luật hiện hành.
        </li>
        <li>
          Không nội dung nào trong Điều khoản này tước bỏ quyền của Thành viên
          trong việc đưa ra yêu cầu trước tòa án hoặc cơ quan có thẩm quyền nếu
          quyền đó được bảo đảm bởi các quy định pháp luật bắt buộc tại quốc gia
          hoặc khu vực nơi Thành viên cư trú.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Điều 23. Quy định khác</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Những vấn đề không được quy định rõ trong Điều khoản này sẽ được điều
          chỉnh bởi pháp luật hiện hành và, trong phạm vi được pháp luật cho
          phép, các thông lệ được thừa nhận chung.
        </li>
        <li>
          Nếu bất kỳ điều khoản nào trong Điều khoản này bị xác định là vô hiệu,
          trái pháp luật hoặc không thể thi hành, các điều khoản còn lại vẫn
          tiếp tục có hiệu lực trong phạm vi tối đa được pháp luật cho phép.
        </li>
        <li>
          Việc Công ty không thực thi bất kỳ điều khoản nào trong Điều khoản này
          không được xem là từ bỏ điều khoản đó hoặc bất kỳ quyền nào khác.
        </li>
        <li>
          Các tiêu đề trong Điều khoản này chỉ nhằm mục đích thuận tiện và không
          ảnh hưởng đến việc giải thích Điều khoản.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Điều khoản bổ sung</PolicyArticleTitle>
      <PolicyText>
        Điều khoản này có hiệu lực từ <strong>[21 tháng 9 năm 2026]</strong>.
      </PolicyText>
      <PolicyText>
        Đối với Thành viên đăng ký mới sau khi Điều khoản này được công bố nhưng
        trước ngày có hiệu lực nêu trên, Công ty có thể áp dụng Điều khoản này
        kể từ ngày đăng ký trong phạm vi pháp luật hiện hành cho phép.
      </PolicyText>
    </PolicyContainer>
  );
};

export default ServiceVi;
